export default __webpack_public_path__ + "static/media/productImage3.87540e7f.png";